import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","text-align":"center"},
  class: "mt-4"
}

import { ref, onMounted } from 'vue'
import request from "../common/request";
import { message } from "ant-design-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

let entity = ref({
  secret: '',
  activateCode: '',
  exp: ''
})

onMounted(async () => {
  await getActiveInfo();
})

const getActiveInfo = async () => {
  let result = await request.get('/draw/api/activated')
  if (result?.data) {
    entity.value.secret = result.data.mac_code;
    entity.value.activateCode = result.data.activation_code?.code;
    entity.value.exp = result.data.activation_code?.exp;
  }
}

const onSubmit = async () => {
  if (!entity.value.activateCode) {
    return;
  }
  let result: any = await request.post("/draw/api/activated", { code: entity.value.activateCode });
  if (result?.data) {
    message.success('保存成功');
    await getActiveInfo();
    emit('success');
  } else {
    message.error('注册码无效')
  }

}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "Secret",
        name: "secret"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            type: "text",
            value: _unref(entity).secret,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(entity).secret) = $event)),
            readonly: ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "注册码",
        name: "activateCode"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            type: "text",
            value: _unref(entity).activateCode,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(entity).activateCode) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "有效期",
        name: "exp"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            type: "text",
            value: _unref(entity).exp,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(entity).exp) = $event)),
            readonly: ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("提交")
          ])),
          _: 1,
          __: [3]
        })
      ])
    ]),
    _: 1
  }))
}
}

})